// Gender is not a frontend enum — it's fetched live from the backend
// (`GET /StaffManagement/genders`, and `profile.gender.name` on user
// profiles) as free-form `{ id, name }` pairs. This normalizes the known
// values to a translation key and falls back to the raw backend value for
// anything unrecognized, so an unexpected value never shows `undefined` or
// crashes the UI.
const GENDER_NAME_TRANSLATION_KEYS = {
   male: "male-label",
   female: "female-label"
};

export const translateGenderName = (rawGenderName, t) => {
   if (!rawGenderName) return "";
   const translationKey = GENDER_NAME_TRANSLATION_KEYS[rawGenderName.trim().toLowerCase()];
   return translationKey ? t(translationKey) : rawGenderName;
};
